import _Vue from 'vue'
import moment from 'moment'
import 'moment/locale/de'

export function MomentPlugin(Vue: typeof _Vue): void {
  Vue.prototype.$moment = moment
}
